// extracted by mini-css-extract-plugin
export default {"title":"_3003b28ccd","bld":"_4f6c70fe7c"};